/* Carrinho Shopify — fluxo simples: add/change → cart.js → UI.
   Páginas preenchem window.IMG_VARIANTS e window.IMG_SHOPIFY.
   API: window.IMGCart = { add, open, close, change, remove, qtyInCart,
   maxStock, subscribe, refreshStock, reload, state } */
(function () {
  'use strict';

  if (window.__IMG_CARRINHO_INIT__) return;
  window.__IMG_CARRINHO_INIT__ = true;

  window.IMG_CART_READY = true;

  var CFG = window.IMG_SHOPIFY || {};
  var MSG_FRETE = 'Frete calculado no checkout.';
  var carrinho = { items: [], item_count: 0, total_price: 0, currency: 'BRL' };
  var filaCart = Promise.resolve();
  var opsPendentes = 0;
  var assinantes = [];
  var bloqueioApiAte = 0;
  var variantRefreshEm = {};
  var timerAvisoSucesso = null;
  var MS_AVISO_SUCESSO = 2000;
  var MS_AVISO_FADE = 280;
  var ultimoCodigoPromoAplicado = null;
  /** Evita dois postAdd na mesma variant enquanto o primeiro add ainda não terminou. */
  var addPorVariantEmVoo = Object.create(null);
  var qtyPorVariantEmVoo = Object.create(null);

  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function VARIANTES() { return window.IMG_VARIANTS || {}; }

  function idVar(v) {
    if (v == null || v === '') return '';
    return String(v).trim();
  }

  function mesmosIds(a, b) {
    return idVar(a) === idVar(b);
  }

  function msgRateLimit() {
    return 'Muitas tentativas em pouco tempo. Aguarde cerca de 2 minutos e tente de novo.';
  }

  function ehRateLimit(err) {
    if (!err) return false;
    if (err.httpStatus === 429) return true;
    if (err.status === 429 || err.status === 'too_many_requests') return true;
    var txt = String(err.message || err.description || '').toLowerCase();
    return txt.indexOf('too_many') !== -1 || txt.indexOf('excess') !== -1;
  }

  function registrarRateLimit() {
    bloqueioApiAte = Date.now() + 120000;
  }

  function apiBloqueada() {
    return Date.now() < bloqueioApiAte;
  }

  function tratarRateLimit(err) {
    if (!ehRateLimit(err)) return false;
    registrarRateLimit();
    return true;
  }

  function infoVariante(variantId) {
    var id = idVar(variantId);
    return id ? (VARIANTES()[id] || null) : null;
  }

  /** Vídeo na galeria do produto vira featured_image — checkout/cart não devem usar isso como foto do pote. */
  function urlImagemProdutoUtil(url) {
    if (!url || typeof url !== 'string') return false;
    var u = url.toLowerCase();
    if (u.indexOf('/videos/') !== -1) return false;
    if (/\.(mp4|webm|mov|m3u8)(\?|$)/.test(u)) return false;
    return true;
  }

  function aplicarDadosVariante(v) {
    if (!v || v.id == null) return;
    var id = idVar(v.id);
    if (!id) return;
    var vars = VARIANTES();
    if (!vars[id]) vars[id] = { produto: v.name || 'Produto', variante: v.title || '' };
    vars[id].available = !!v.available;
    vars[id].inventory_management = v.inventory_management;
    vars[id].inventory_policy = v.inventory_policy || vars[id].inventory_policy;
    vars[id].inventory_quantity = v.inventory_management ? v.inventory_quantity : null;
    if (v.price != null) vars[id].preco = v.price;
    if (vars[id].imagemFixa) {
      return;
    }
    if (v.featured_image && v.featured_image.src) {
      var src = v.featured_image.src;
      if (urlImagemProdutoUtil(src)) {
        vars[id].imagem = src;
      }
    }
  }

  function mensagemIndisponivel(info) {
    if (!info) {
      return 'Produto indisponível na Shopify. Confira se está publicado na Loja online.';
    }
    var nome = info.produto || 'Este produto';
    return nome + ' esgotado ou indisponível no momento.';
  }

  function notificar() {
    assinantes.forEach(function (fn) { try { fn(carrinho); } catch (e) { console.error(e); } });
  }

  function enfileirarCart(fn) {
    var run = filaCart.then(function () {
      return Promise.resolve(fn());
    });
    filaCart = run.catch(function () {});
    return run;
  }

  function atualizarControlesQuantidade() {
    qsa('[data-ch-menos], [data-ch-mais]').forEach(function (btn) {
      btn.removeAttribute('aria-disabled');
      if (btn.hasAttribute('data-ch-estoque-max')) {
        btn.disabled = true;
      } else {
        btn.disabled = false;
      }
    });
  }

  function atualizarBotaoCheckout() {
    qsa('[data-ch-checkout]').forEach(function (btn) {
      if (btn.getAttribute('aria-busy') === 'true') return;
      var bloqueado = opsPendentes > 0 || !carrinho.item_count;
      if (bloqueado) {
        btn.setAttribute('aria-disabled', 'true');
        btn.classList.add('ch-botao--aguardando');
      } else {
        btn.removeAttribute('aria-disabled');
        btn.classList.remove('ch-botao--aguardando');
      }
    });
  }

  function atualizarUiBloqueioCart() {
    atualizarBotaoCheckout();
    atualizarControlesQuantidade();
  }

  /** Enfileira e bloqueia checkout até a Shopify responder. */
  function comFila(fn) {
    opsPendentes++;
    atualizarUiBloqueioCart();
    return enfileirarCart(fn).finally(function () {
      opsPendentes--;
      atualizarUiBloqueioCart();
    });
  }

  /**
   * A Shopify pode devolver o mesmo variant em várias linhas no cart.js
   * (ex.: quando o desconto automático/cupom pega só parte das unidades).
   * Aqui devolvemos TODAS as linhas de um variant.
   */
  function linhasDaVariante(variantId) {
    return (carrinho.items || []).filter(function (i) {
      return mesmosIds(i.variant_id, variantId);
    });
  }

  /**
   * Agrupa linhas do cart.js por variant (sabor). Ordem = 1ª aparição na resposta Shopify.
   * Só para exibição; carrinho.items bruto continua igual até o próximo GET.
   */
  function agruparItensPorVariante(items) {
    var resultado = [];
    var indicePorVariante = {};
    (items || []).forEach(function (i) {
      var vid = idVar(i.variant_id);
      if (!vid || indicePorVariante[vid] == null) {
        indicePorVariante[vid] = resultado.length;
        resultado.push(i);
        return;
      }
      var base = resultado[indicePorVariante[vid]];
      if (!base.__agrupado) {
        var copia = {};
        Object.keys(base).forEach(function (k) { copia[k] = base[k]; });
        copia.__agrupado = true;
        resultado[indicePorVariante[vid]] = copia;
        base = copia;
      }
      ['quantity', 'line_price', 'final_line_price', 'original_line_price', 'total_discount']
        .forEach(function (campo) {
          if (i[campo] != null || base[campo] != null) {
            base[campo] = (Number(base[campo]) || 0) + (Number(i[campo]) || 0);
          }
        });
    });
    return resultado;
  }

  function vendeSemEstoque(info) {
    return info && info.inventory_policy === 'continue';
  }

  function estoqueMaximo(info) {
    if (!info) return 999;
    if (vendeSemEstoque(info)) return 999;
    if (!info.available) return 0;
    if (info.inventory_management === 'shopify' && info.inventory_quantity != null) {
      return Math.max(0, info.inventory_quantity);
    }
    return 999;
  }

  function qtdNoCarrinho(variantId) {
    return linhasDaVariante(variantId).reduce(function (t, i) {
      return t + (i.quantity || 0);
    }, 0);
  }

  function validarEstoque(variantId, qtd) {
    qtd = qtd || 1;
    var info = infoVariante(variantId);
    if (!info) return { ok: true };
    if (!info.available && !vendeSemEstoque(info)) {
      return { ok: false, msg: mensagemIndisponivel(info) };
    }
    if (estoqueMaximo(info) <= 0) return { ok: false, msg: mensagemIndisponivel(info) };
    var max = estoqueMaximo(info);
    var noCarrinho = qtdNoCarrinho(variantId);
    if (noCarrinho + qtd > max) {
      var restante = Math.max(0, max - noCarrinho);
      if (restante <= 0) {
        return { ok: false, msg: 'Estoque esgotado para ' + (info.produto || 'este produto') + '.' };
      }
      return { ok: false, msg: 'Só restam ' + restante + ' unidade' + (restante === 1 ? '' : 's') + ' em estoque.' };
    }
    return { ok: true };
  }

  function urlCheckout() {
    var u = CFG.checkout || '';
    if (u && String(u).indexOf('checkout') !== -1) {
      u = String(u);
      if (/^https?:\/\/[^/]+checkout/.test(u)) {
        u = u.replace(/^(https?:\/\/[^/]+)checkout/, '$1/checkout');
      }
      return u;
    }
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || CFG.root || '/';
    root = String(root);
    if (root.indexOf('http') === 0) {
      if (root.slice(-1) !== '/') root += '/';
      return root + 'checkout';
    }
    return '/checkout';
  }

  function urlCart(tipo) {
    if (tipo === 'add' && CFG.cartAdd) return CFG.cartAdd;
    if (tipo === 'change' && CFG.cartChange) return CFG.cartChange;
    if (tipo === 'get' && CFG.cartGet) return CFG.cartGet;
    if (tipo === 'update' && CFG.cartUpdate) return CFG.cartUpdate;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || CFG.root || '/';
    if (root.slice(-1) !== '/') root += '/';
    var map = { add: 'cart/add.js', change: 'cart/change.js', get: 'cart.js', update: 'cart/update.js' };
    return root + map[tipo];
  }

  function cfgPromoDuo() {
    return CFG.promoDuo || {};
  }

  function variantEhCreatina(vid) {
    var ids = cfgPromoDuo().creatinaVariantIds || [];
    for (var i = 0; i < ids.length; i++) {
      if (mesmosIds(ids[i], vid)) return true;
    }
    return false;
  }

  function variantEhKit(vid) {
    var ids = cfgPromoDuo().kitVariantIds;
    if (Array.isArray(ids) && ids.length) {
      for (var i = 0; i < ids.length; i++) {
        if (mesmosIds(ids[i], vid)) return true;
      }
    }
    var kitId = cfgPromoDuo().kitVariantId;
    return kitId != null && kitId !== '' && mesmosIds(kitId, vid);
  }

  function linhaPrecoCheio(item) {
    var fin = item.final_line_price != null ? item.final_line_price : (item.line_price || 0);
    var orig = item.original_line_price != null ? item.original_line_price : fin;
    return { cheio: orig, pago: fin };
  }

  function precoUnitCreatinaMaxCent() {
    var ids = cfgPromoDuo().creatinaVariantIds || [];
    var maxUnit = 0;
    ids.forEach(function (id) {
      var info = infoVariante(id);
      if (info && info.preco) maxUnit = Math.max(maxUnit, Number(info.preco) || 0);
    });
    if (maxUnit > 0) return maxUnit;
    var kitId = cfgPromoDuo().kitVariantId;
    Object.keys(VARIANTES()).forEach(function (id) {
      if (kitId != null && kitId !== '' && mesmosIds(id, kitId)) return;
      var info = VARIANTES()[id];
      if (info && info.preco) maxUnit = Math.max(maxUnit, Number(info.preco) || 0);
    });
    return maxUnit;
  }

  function precoRefDuasUnidadesCent() {
    var ids = cfgPromoDuo().creatinaVariantIds || [];
    var soma = 0;
    var n = 0;
    ids.forEach(function (id) {
      var info = infoVariante(id);
      if (info && info.preco) {
        soma += Number(info.preco) || 0;
        n++;
      }
    });
    if (soma > 0 && n >= 2) return soma;
    if (soma > 0 && n === 1) return soma * 2;
    var u = precoUnitCreatinaMaxCent();
    return u > 0 ? u * 2 : 0;
  }

  function precoUnitItemCent(item) {
    var info = infoVariante(item.variant_id);
    return (info && info.preco) || item.price || 0;
  }

  /** Subtotal de referência (antes do 10% duo/kit) para o resumo do drawer. */
  function valorLinhaReferencia(item) {
    var q = item.quantity || 0;
    if (q <= 0) return 0;
    var precos = linhaPrecoCheio(item);
    var unit = precoUnitItemCent(item);

    if (variantEhKit(item.variant_id)) {
      var refKit = precoRefDuasUnidadesCent() * q;
      if (refKit > 0) return refKit;
      var pct = typeof cfgPromoDuo().percentual === 'number' ? cfgPromoDuo().percentual : 0.1;
      if (unit > 0 && pct > 0 && pct < 1) return Math.round((unit * q) / (1 - pct));
      return precos.cheio || precos.pago || unit * q;
    }

    if (variantEhCreatina(item.variant_id)) {
      if (unit > 0) return unit * q;
      return precos.cheio || precos.pago;
    }

    return precos.cheio || precos.pago || unit * q;
  }

  function subtotalParaExibicao(cart) {
    cart = cart || carrinho;
    var itens = cart.items || [];
    if (!itens.length) return 0;
    var total = 0;
    itens.forEach(function (item) {
      total += valorLinhaReferencia(item);
    });
    if (total > 0) return total;
    return subtotalOriginal(cart);
  }

  function idsCreatinaCfg() {
    return (cfgPromoDuo().creatinaVariantIds || []).map(function (id) {
      return idVar(id);
    }).filter(function (id) { return id !== ''; });
  }

  function qtyCreatinaPorVariante(cart) {
    var map = {};
    (cart.items || []).forEach(function (item) {
      if (!variantEhCreatina(item.variant_id)) return;
      var vid = idVar(item.variant_id);
      map[vid] = (map[vid] || 0) + (item.quantity || 0);
    });
    return map;
  }

  /**
   * Sobras de 1 pote por sabor (qty ímpar), na ordem em que o sabor aparece no carrinho.
   * Depois tentamos fechar par só entre essas sobras (ex.: 1 morango + 1 uva).
   */
  function sobrasCreatinaPorSabor(cart) {
    var qty = qtyCreatinaPorVariante(cart);
    var jaListado = {};
    var sobras = [];
    (cart.items || []).forEach(function (item) {
      if (!variantEhCreatina(item.variant_id)) return;
      var vid = idVar(item.variant_id);
      if (jaListado[vid]) return;
      if ((qty[vid] || 0) % 2 !== 1) return;
      jaListado[vid] = true;
      sobras.push({ variantId: vid, unitCent: precoUnitItemCent(item) });
    });
    return sobras;
  }

  /** Quantas unidades de cada variant entram no 10% (par no mesmo sabor; depois par entre sobras). */
  function unidadesComDescontoPorVariante(cart) {
    var qty = qtyCreatinaPorVariante(cart);
    var map = {};
    Object.keys(qty).forEach(function (vid) {
      map[vid] = Math.floor((qty[vid] || 0) / 2) * 2;
    });
    var sobras = sobrasCreatinaPorSabor(cart);
    var limiteCross = Math.floor(sobras.length / 2) * 2;
    for (var i = 0; i < limiteCross; i++) {
      var id = sobras[i].variantId;
      map[id] = (map[id] || 0) + 1;
    }
    return map;
  }

  /** 10%: pares no mesmo sabor; sobras de sabores diferentes podem fechar par entre si. */
  function calcPromoCreatinaAvulsa(cart, pct) {
    var qty = qtyCreatinaPorVariante(cart);
    var unit = {};
    (cart.items || []).forEach(function (item) {
      if (!variantEhCreatina(item.variant_id)) return;
      var vid = idVar(item.variant_id);
      var u = precoUnitItemCent(item);
      if (u) unit[vid] = u;
    });

    var desconto = 0;
    var potesComDesc = 0;
    Object.keys(qty).forEach(function (vid) {
      var q = qty[vid] || 0;
      var paresIntra = Math.floor(q / 2);
      var u = unit[vid] || 0;
      if (paresIntra > 0 && u > 0) {
        desconto += paresIntra * Math.round(2 * u * pct);
        potesComDesc += paresIntra * 2;
      }
    });

    var sobras = sobrasCreatinaPorSabor(cart);
    var paresCross = Math.floor(sobras.length / 2);
    for (var p = 0; p < paresCross; p++) {
      var u1 = sobras[p * 2].unitCent;
      var u2 = sobras[p * 2 + 1].unitCent;
      desconto += Math.round((u1 + u2) * pct);
      potesComDesc += 2;
    }

    var potes = 0;
    Object.keys(qty).forEach(function (vid) { potes += qty[vid] || 0; });

    var ultimaVarianteSolta = null;
    if (sobras.length % 2 === 1) {
      ultimaVarianteSolta = sobras[sobras.length - 1].variantId;
    }

    return {
      pares: Math.floor(potesComDesc / 2),
      leftover: potes - potesComDesc,
      desconto: desconto,
      potes: potes,
      ultimaVarianteSolta: ultimaVarianteSolta
    };
  }

  /** Quantos potes desta linha entram no desconto (por sabor + sobras cruzadas). */
  function criarAlocadorDescontoCreatina(cart) {
    var porVariante = unidadesComDescontoPorVariante(cart);
    var usadoPorVariante = {};
    return function qtdDescontoNaLinha(item) {
      if (!variantEhCreatina(item.variant_id)) return 0;
      var vid = idVar(item.variant_id);
      var q = item.quantity || 0;
      var totalDesc = porVariante[vid] || 0;
      var jaUsado = usadoPorVariante[vid] || 0;
      var restante = Math.max(0, totalDesc - jaUsado);
      var nestaLinha = Math.min(q, restante);
      usadoPorVariante[vid] = jaUsado + nestaLinha;
      return nestaLinha;
    };
  }

  /** Kit sempre 10% (2 creatinas); avulsos 10% a cada par completo. */
  function analisarPromoDuo(cart) {
    var promo = cfgPromoDuo();
    var pct = typeof promo.percentual === 'number' ? promo.percentual : 0.1;
    var kits = 0;
    var descontoKit = 0;
    var creatinaStats = calcPromoCreatinaAvulsa(cart, pct);

    (cart.items || []).forEach(function (item) {
      if (!variantEhKit(item.variant_id)) return;
      var q = item.quantity || 0;
      kits += q;
      var ref = precoRefDuasUnidadesCent() * q;
      if (ref <= 0) {
        var unitKit = precoUnitItemCent(item);
        if (unitKit > 0 && pct > 0 && pct < 1) ref = Math.round((unitKit * q) / (1 - pct));
      }
      if (ref <= 0) return;
      descontoKit += Math.round(ref * pct);
    });

    var linhas = [];
    var descontoTotal = 0;

    if (creatinaStats.desconto > 0) {
      var qtdComDesc = creatinaStats.pares * 2;
      var rotuloDuo = promo.rotuloDuo || 'Desconto par de potes (10%)';
      if (creatinaStats.pares > 1) {
        rotuloDuo = 'Desconto ' + qtdComDesc + ' potes (10%)';
      }
      linhas.push({ rotulo: rotuloDuo, valor: creatinaStats.desconto });
      descontoTotal += creatinaStats.desconto;
    }

    if (kits > 0 && descontoKit > 0) {
      linhas.push({ rotulo: promo.rotuloKit || 'Desconto kit (10%)', valor: descontoKit });
      descontoTotal += descontoKit;
    }

    return {
      elegivel: linhas.length > 0,
      linhas: linhas,
      descontoTotal: descontoTotal,
      potes: creatinaStats.potes,
      paresCreatina: creatinaStats.pares,
      leftoverCreatina: creatinaStats.leftover,
      ultimaVarianteSolta: creatinaStats.ultimaVarianteSolta,
      kits: kits
    };
  }

  function pctPromoNum() {
    var promo = cfgPromoDuo();
    return typeof promo.percentual === 'number' ? promo.percentual : 0.1;
  }

  function precoComPromoCent(cheioCent) {
    return Math.round((Number(cheioCent) || 0) * (1 - pctPromoNum()));
  }

  /** Há desconto legítimo para exibir (DUOPAR / cupom externo), não resquício ou PIX. */
  function descontoPromoAtivoNoCarrinho(cart) {
    cart = cart || carrinho;
    if (cupomExternoNoCart(cart) && descontoTotalShopifyComparacao(cart) > 0) return true;
    var promo = analisarPromoDuo(cart);
    if (!promo.elegivel || promo.descontoTotal <= 0) return false;
    return usarPromoVitrine(cart);
  }

  function linhaComDescontoShopify(item) {
    var pago = item.final_line_price != null ? item.final_line_price : (item.line_price || 0);
    var cheio = item.original_line_price != null ? item.original_line_price : pago;
    if (cheio > pago + 1) return true;
    var allocs = item.line_level_discount_allocations || [];
    for (var i = 0; i < allocs.length; i++) {
      var app = allocs[i].discount_application || {};
      if (ehDescontoPix(app)) continue;
      if ((Number(allocs[i].amount) || 0) > 0) return true;
    }
    return false;
  }

  /** Creatina avulsa: preço/tarja pela regra do par, não pelo rateio do cupom na Shopify. */
  function exibirCreatinaPorRegraPar(cart) {
    cart = cart || carrinho;
    var promo = analisarPromoDuo(cart);
    if (!promo.elegivel || promo.descontoTotal <= 0) return false;
    if (usarPromoVitrine(cart)) return true;
    if (nossoCupomPromoAplicado(cart)) return true;
    return false;
  }

  /** Preços da Shopify por linha (kit pode manter cálculo local se o cupom não refletiu na linha). */
  function precoUsaShopify(cart, item) {
    cart = cart || carrinho;
    if (!descontoPromoAtivoNoCarrinho(cart)) return true;
    if (!usarPromoVitrine(cart)) return true;
    if (cupomExternoNoCart(cart) && descontoTotalShopifyComparacao(cart) > 0) return true;
    if (nossoCupomPromoAplicado(cart)) {
      if (item && variantEhCreatina(item.variant_id) && exibirCreatinaPorRegraPar(cart)) return false;
      if (item && variantEhKit(item.variant_id) && !linhaComDescontoShopify(item)) return false;
      return true;
    }
    return false;
  }

  /**
   * Preço da creatina avulsa pela regra do par (não pelo rateio da Shopify).
   * Com outra promo já no carrinho, o cupom pode marcar a linha inteira;
   * pote que ainda não fechou dupla fica no preço cheio, sem tarja.
   * Linha com par (2, 3, 4…) mantém a tarja — no ímpar o valor mistura
   * os potes com 10% e o pote cheio.
   */
  function precoCreatinaPelaDupla(item, qDescLinha, cheioShopify) {
    var qDesc = typeof qDescLinha === 'number' ? qDescLinha : 0;
    var q = item.quantity || 0;
    var unit = precoUnitItemCent(item);
    if (qDesc <= 0 || unit <= 0) {
      var cheio0 = unit > 0 ? unit * q : cheioShopify;
      return { promo: false, cheio: cheio0, pago: cheio0 };
    }
    var cheioC = unit * q;
    var pagoC = Math.round(unit * qDesc * (1 - pctPromoNum())) + unit * (q - qDesc);
    return { promo: pagoC < cheioC, cheio: cheioC, pago: pagoC, parcial: qDesc < q };
  }

  function precoExibicaoItem(item, cart, qDescLinha) {
    cart = cart || carrinho;
    var pagoShopify = item.final_line_price != null ? item.final_line_price : (item.line_price || 0);
    var cheioShopify = item.original_line_price != null ? item.original_line_price : pagoShopify;

    if (variantEhCreatina(item.variant_id) && exibirCreatinaPorRegraPar(cart)) {
      return precoCreatinaPelaDupla(item, qDescLinha, cheioShopify);
    }

    if (precoUsaShopify(cart, item)) {
      if (!descontoPromoAtivoNoCarrinho(cart)) {
        var cheioSemDesc = item.original_line_price != null ? item.original_line_price : pagoShopify;
        return { promo: false, cheio: cheioSemDesc, pago: cheioSemDesc };
      }
      return {
        promo: cheioShopify > pagoShopify + 1,
        cheio: cheioShopify,
        pago: pagoShopify
      };
    }

    var pct = pctPromoNum();
    var q = item.quantity || 0;

    if (variantEhKit(item.variant_id)) {
      var promoKit = analisarPromoDuo(cart);
      if (!promoKit.kits) return { promo: false, cheio: 0, pago: pagoShopify };
      var cheioK = valorLinhaReferencia(item);
      if (cheioK <= 0) cheioK = pagoShopify;
      var pagoK = precoComPromoCent(cheioK);
      if (pagoShopify > 0 && pagoShopify < cheioK) pagoK = pagoShopify;
      return { promo: true, cheio: cheioK, pago: pagoK };
    }

    if (variantEhCreatina(item.variant_id)) {
      var qDesc = typeof qDescLinha === 'number' ? qDescLinha : 0;
      if (qDesc <= 0) return { promo: false, cheio: 0, pago: pagoShopify };
      var unit = precoUnitItemCent(item);
      if (unit <= 0) return { promo: false, cheio: 0, pago: pagoShopify };
      var cheioC = unit * q;
      var pagoC = Math.round(unit * qDesc * (1 - pct)) + unit * (q - qDesc);
      return { promo: true, cheio: cheioC, pago: pagoC, parcial: qDesc < q };
    }

    return { promo: false, cheio: 0, pago: pagoShopify };
  }

  /**
   * Tarja "10% off" (só visual — não usa rateio da Shopify).
   * Kit: sempre com tarja quando a promo par/kit vale.
   * Creatina avulsa: tarja só se alguma unidade da linha entra num par (qDesc > 0).
   */
  function itemMostraTarja10(item, cart, qDescNaLinha) {
    cart = cart || carrinho;
    var promo = analisarPromoDuo(cart);
    if (!promo.elegivel) return false;

    if (variantEhKit(item.variant_id)) {
      return promo.kits > 0;
    }

    if (variantEhCreatina(item.variant_id)) {
      var qDesc = Number(qDescNaLinha) || 0;
      if (qDesc <= 0) return false;
      return true;
    }

    return false;
  }

  function htmlPrecoItem(item, cart, qDescLinha) {
    var ex = precoExibicaoItem(item, cart, qDescLinha);
    var pago = Number(ex.pago) || 0;

    if (!itemMostraTarja10(item, cart, qDescLinha)) {
      return '<span class="ch-item__preco">' + reais(pago) + '</span>';
    }

    var cheio = Number(ex.cheio) || 0;
    if (variantEhKit(item.variant_id)) {
      var refKit = valorLinhaReferencia(item);
      if (refKit > pago) cheio = refKit;
    }
    if (cheio <= pago) {
      return '<span class="ch-item__preco">' + reais(pago) + '</span>';
    }

    return '<span class="ch-item__preco ch-item__preco--promo">' +
      '<span class="ch-item__selo">10% off</span>' +
      '<span class="ch-item__preco-valores">' +
      '<span class="ch-item__preco-por">' + reais(pago) + '</span>' +
      '<span class="ch-item__preco-de">' + reais(cheio) + '</span>' +
      '</span></span>';
  }

  function htmlTotalComPromo(subtotal, total) {
    return '<span class="ch-carrinho__total-wrap">' +
      '<span class="ch-carrinho__total-valores">' +
      '<span class="ch-carrinho__total-por">' + escHtml(reais(total)) + '</span>' +
      '<span class="ch-carrinho__total-de">' + escHtml(reais(subtotal)) + '</span>' +
      '</span></span>';
  }

  function rotuloVarianteCurto(variantId) {
    var info = infoVariante(variantId);
    if (!info) return 'este sabor';
    return info.variante || info.produto || 'este sabor';
  }

  function htmlUpsellFecharPar(cart) {
    var promo = analisarPromoDuo(cart);
    if (promo.leftoverCreatina !== 1 || !promo.ultimaVarianteSolta) return '';
    /* Cupom externo melhor que o par: não incentivar 10% que não vai valer. */
    if (cupomExternoNoCart(cart) && !usarPromoVitrine(cart)) return '';
    var ultima = promo.ultimaVarianteSolta;
    var ids = idsCreatinaCfg();
    var vistos = {};
    var botoes = [];

    function addBotao(id) {
      id = idVar(id);
      if (!id || vistos[id]) return;
      vistos[id] = true;
      var sabor = rotuloVarianteCurto(id);
      botoes.push({
        id: id,
        rotulo: id === ultima
          ? ('+1 de ' + sabor)
          : ('Quero provar ' + sabor)
      });
    }

    addBotao(ultima);
    ids.forEach(addBotao);

    if (!botoes.length) return '';

    var btnsHtml = botoes.map(function (b) {
      return '<button type="button" class="ch-upsell__btn" data-ch-upsell-add="' + b.id + '">' +
        escHtml(b.rotulo) + '</button>';
    }).join('');

    return '<aside class="ch-upsell" data-ch-upsell-par role="note">' +
      '<p class="ch-upsell__titulo">Seu ritual fica melhor em dupla.</p>' +
      '<p class="ch-upsell__texto">Adicione mais 1 pote e ganhe 10% off nos dois. Vale repetir o sabor ou variar.</p>' +
      '<div class="ch-upsell__acoes">' + btnsHtml + '</div>' +
      '</aside>';
  }

  function totalPromoEsperadoCent(cart) {
    var promo = analisarPromoDuo(cart);
    if (!promo.elegivel || promo.descontoTotal <= 0) return null;
    return Math.max(0, subtotalParaExibicao(cart) - promo.descontoTotal);
  }

  /** Total do cart.js bate com o 10% par/kit (ou cupom DUO já aplicado). */
  function descontoPromoRefletidoNoCart(cart) {
    cart = cart || carrinho;
    if (nossoCupomPromoAplicado(cart)) return true;
    var promo = analisarPromoDuo(cart);
    if (!promo.elegivel || promo.descontoTotal <= 0) return true;
    if (descontoTotalShopifyComparacao(cart) > 0) return true;
    if (!usarPromoVitrine(cart)) return false;
    var esperado = totalPromoEsperadoCent(cart);
    if (esperado == null) return true;
    var atual = totalShopifyParaComparacao(cart);
    return Math.abs(atual - esperado) <= 10;
  }

  function precisaCupomPromoDuoNoCart(cart) {
    if (!autoAplicarCodigoDuoparCfg()) return false;
    if (!codigoPromoDuoCfg()) return false;
    if (cupomExternoNoCart(cart)) return false;
    var promo = analisarPromoDuo(cart);
    if (!promo.elegivel || promo.descontoTotal <= 0) return false;
    if (promo.leftoverCreatina > 0) return false;
    if (!usarPromoVitrine(cart)) return false;
    return !nossoCupomPromoAplicado(cart);
  }

  function sincronizarCodigoPromoDuo(data, opcoes) {
    opcoes = opcoes || {};
    var codigo = codigoPromoDuoCfg();
    if (!codigo) return Promise.resolve(data);
    var analise = analisarPromoDuo(data);
    var alvo;

    if (deveRemoverCupomDuopar(data)) {
      alvo = '';
    } else if (precisaCupomPromoDuoNoCart(data)) {
      alvo = codigo;
    } else if (cupomExternoNoCart(data)) {
      return Promise.resolve(data);
    } else if (
      !analise.elegivel &&
      (nossoCupomPromoAplicado(data) ||
        ultimoCodigoPromoAplicado === codigo ||
        descontoTotalShopifyComparacao(data) > 0)
    ) {
      alvo = '';
    } else {
      return Promise.resolve(data);
    }

    if (!opcoes.forcar && alvo === codigo && ultimoCodigoPromoAplicado === codigo && nossoCupomPromoAplicado(data)) {
      return Promise.resolve(data);
    }
    if (!opcoes.forcar && !alvo && !ultimoCodigoPromoAplicado && !nossoCupomPromoAplicado(data)) {
      return Promise.resolve(data);
    }
    if (apiBloqueada()) return Promise.resolve(data);

    return fetch(urlCart('update'), {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ discount: alvo })
    })
      .then(parseRespostaCart)
      .then(function (updated) {
        ultimoCodigoPromoAplicado = alvo;
        if (alvo && !descontoPromoRefletidoNoCart(updated)) {
          console.warn(
            '[IMGCart] Cupom "' + alvo + '" no carrinho; total da Shopify pode divergir do preview — o checkout confirma o valor.'
          );
        }
        carrinho = updated;
        desenharCarrinho();
        return updated;
      })
      .catch(function (err) {
        ultimoCodigoPromoAplicado = null;
        console.warn('[IMGCart] cupom promo duo', err);
        return data;
      });
  }

  function parseRespostaCart(r) {
    return r.json().then(function (data) {
      if (!r.ok) {
        if (data && typeof data === 'object') {
          data.httpStatus = r.status;
          if (r.status === 429) data.status = 'too_many_requests';
        } else {
          data = { httpStatus: r.status, description: 'Erro ' + r.status };
        }
        throw data;
      }
      return data;
    });
  }

  function aplicarCarrinhoServidor(data) {
    carrinho = data;
    desenharCarrinho();
    return data;
  }

  /** GET /cart.js — sem enfileirar (uso dentro de operações já enfileiradas). */
  function buscarCarrinhoDireto() {
    return fetch(urlCart('get'), { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) {
        if (!r.ok) throw new Error('cart ' + r.status);
        return r.json();
      })
      .then(aplicarCarrinhoServidor)
      .then(sincronizarCodigoPromoDuo);
  }

  function buscarCarrinho() {
    return enfileirarCart(function () { return buscarCarrinhoDireto(); });
  }

  function postAdd(variantId, qtd) {
    variantId = idVar(variantId);
    qtd = Math.max(1, qtd || 1);
    if (!variantId) return Promise.reject({ description: 'variant_id inválido' });
    if (apiBloqueada()) {
      return Promise.reject({ status: 'too_many_requests', description: msgRateLimit() });
    }
    return fetch(urlCart('add'), {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: qtd }] })
    }).then(parseRespostaCart).catch(function (err) {
      if (tratarRateLimit(err)) err.description = msgRateLimit();
      throw err;
    });
  }

  function linhasVarianteOrdenadas(cart, variantId) {
    var out = [];
    (cart.items || []).forEach(function (i) {
      if (mesmosIds(i.variant_id, variantId)) out.push(i);
    });
    return out;
  }

  function qtdVarianteNoCartServidor(cart, variantId) {
    return linhasVarianteOrdenadas(cart, variantId).reduce(function (t, i) {
      return t + (i.quantity || 0);
    }, 0);
  }

  function aplicarRespostaCart(data) {
    carrinho = data;
    desenharCarrinho();
    return sincronizarCodigoPromoDuo(data);
  }

  /** cart/update.js devolve o carrinho inteiro; add.js nem sempre — aí fazemos GET. */
  function finalizarMudancaCart(data) {
    if (data && Array.isArray(data.items)) return aplicarRespostaCart(data);
    return buscarCarrinhoDireto();
  }

  function postUpdateCart(updates) {
    return fetch(urlCart('update'), {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates: updates || {} })
    }).then(parseRespostaCart);
  }

  /**
   * Define qty total do sabor. Com várias linhas (promo), update só por variant_id
   * altera a 1ª linha — o resto fica e o total agrupado “salta” (+2 ao clicar −).
   * Por isso enviamos cada line key: qty na 1ª, 0 nas outras (1 request).
   */
  function postDefinirQtyVarianteFromCart(cart, variantId, quantity) {
    variantId = idVar(variantId);
    quantity = Math.max(0, quantity);
    var linhas = linhasVarianteOrdenadas(cart, variantId);
    if (!linhas.length) {
      if (quantity <= 0) return Promise.resolve(cart);
      return postAdd(variantId, quantity).then(function () { return null; });
    }
    var updates = {};
    linhas.forEach(function (linha, idx) {
      if (!linha.key) return;
      updates[String(linha.key)] = idx === 0 ? quantity : 0;
    });
    if (!Object.keys(updates).length) return Promise.resolve(cart);
    return postUpdateCart(updates);
  }

  function postDefinirQtyVariante(variantId, quantity) {
    return fetch(urlCart('get'), { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(parseRespostaCart)
      .then(function (cart) { return postDefinirQtyVarianteFromCart(cart, variantId, quantity); })
      .then(finalizarMudancaCart);
  }

  function postIncrementarVariante(variantId, qtdDelta) {
    variantId = idVar(variantId);
    qtdDelta = Math.max(1, qtdDelta || 1);
    return fetch(urlCart('get'), { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(parseRespostaCart)
      .then(function (cart) {
        var alvo = qtdVarianteNoCartServidor(cart, variantId) + qtdDelta;
        return postDefinirQtyVarianteFromCart(cart, variantId, alvo);
      })
      .then(finalizarMudancaCart);
  }

  var moeda = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' });
  function reais(c) { return moeda.format(c / 100); }

  function escHtml(s) {
    return String(s || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function subtotalOriginal(cart) {
    if (typeof cart.original_total_price === 'number' && cart.original_total_price >= 0) {
      return cart.original_total_price;
    }
    return (cart.items || []).reduce(function (t, i) {
      var orig = i.original_line_price != null ? i.original_line_price : (i.line_price || 0);
      return t + orig;
    }, 0);
  }

  function rotuloDesconto(app, tituloFallback) {
    var titulo = (app && app.title) || tituloFallback || 'Desconto';
    var tipo = app && app.type;
    if (tipo === 'discount_code' || tipo === 'code') {
      return /^cupom/i.test(titulo) ? titulo : ('Cupom ' + titulo);
    }
    if (tipo === 'automatic') return titulo;
    return titulo;
  }

  function codigoPromoDuoCfg() {
    return String(cfgPromoDuo().codigoDesconto || '').trim();
  }

  /**
   * DUOPAR10 (% no pedido) soma com o automático “a cada 2 = 10%” e pode dar 10%
   * no pote unitário. Com desconto automático no admin, o tema só remove o código.
   */
  function autoAplicarCodigoDuoparCfg() {
    return cfgPromoDuo().autoAplicarCodigoDuopar === true;
  }

  function cupomDuoparAssociadoAoCarrinho(cart) {
    var cod = codigoPromoDuoCfg().toUpperCase();
    if (!cod) return false;
    cart = cart || carrinho;
    var codes = cart.discount_codes || [];
    for (var c = 0; c < codes.length; c++) {
      if (String(codes[c].code || '').toUpperCase() === cod) return true;
    }
    return nossoCupomPromoAplicado(cart);
  }

  function deveRemoverCupomDuopar(cart) {
    cart = cart || carrinho;
    if (!codigoPromoDuoCfg() || !cupomDuoparAssociadoAoCarrinho(cart)) return false;
    if (!autoAplicarCodigoDuoparCfg()) return true;
    var promo = analisarPromoDuo(cart);
    if (promo.potes > 0 && promo.leftoverCreatina > 0) return true;
    var esperado = totalPromoEsperadoCent(cart);
    if (esperado == null) return false;
    var atual = totalShopifyParaComparacao(cart);
    return Math.abs(atual - esperado) > 15;
  }

  /** Valor na linha “Cupom DUOPAR10” (só vitrine; checkout usa desconto automático). */
  function valorDescontoInformativoDuopar(cart) {
    cart = cart || carrinho;
    var promo = analisarPromoDuo(cart);
    if (!promo.elegivel || promo.descontoTotal <= 0) return 0;
    if (!autoAplicarCodigoDuoparCfg() && !nossoCupomPromoAplicado(cart)) {
      var descShopify = descontoTotalShopifyComparacao(cart);
      if (descShopify > 0) return descShopify;
    }
    return valorDescontoPromoExibido(cart);
  }

  function descontoTotalShopify(cart) {
    cart = cart || carrinho;
    var d = Number(cart.total_discount);
    if (d > 0) return d;
    var sub = subtotalOriginal(cart);
    var tot = Number(cart.total_price) || 0;
    return sub > tot ? sub - tot : 0;
  }

  function rotulosDescontoPixCfg() {
    var cfg = cfgPromoDuo().rotulosDescontoPix;
    if (Array.isArray(cfg) && cfg.length) return cfg;
    return ['pix', 'pagamento instant'];
  }

  /** PIX não disputa 10% vs cupom; no checkout soma ao desconto já aplicado. */
  function ehDescontoPix(app) {
    if (!app) return false;
    var titulo = String(app.title || app.code || '').toLowerCase();
    if (!titulo) return false;
    var rotulos = rotulosDescontoPixCfg();
    for (var i = 0; i < rotulos.length; i++) {
      var r = String(rotulos[i] || '').toLowerCase();
      if (r && titulo.indexOf(r) !== -1) return true;
    }
    return false;
  }

  function valorDescontoPixNoCart(cart) {
    cart = cart || carrinho;
    var soma = 0;

    (cart.cart_level_discount_applications || []).forEach(function (app) {
      if (!ehDescontoPix(app)) return;
      var valor = app.total_allocated_amount;
      if (valor == null) valor = app.amount;
      soma += Number(valor) || 0;
    });

    (cart.items || []).forEach(function (item) {
      (item.line_level_discount_allocations || []).forEach(function (alloc) {
        var app = alloc.discount_application || {};
        if (!ehDescontoPix(app)) return;
        soma += Number(alloc.amount) || 0;
      });
    });

    if (soma > 0) return soma;

    var promo = analisarPromoDuo(cart);
    if (promo.elegivel || cupomExternoNoCart(cart) || nossoCupomPromoAplicado(cart)) return 0;
    var sub = subtotalOriginal(cart);
    var desc = descontoTotalShopify(cart);
    var pct = percentualPixCheckoutCfg();
    if (!sub || !desc || !pct) return 0;
    var esperadoPix = Math.round(sub * pct);
    var margem = Math.max(5, Math.round(sub * 0.02));
    if (Math.abs(desc - esperadoPix) <= margem) return desc;
    return 0;
  }

  /** Descontos no cart.js exceto PIX (para comparar par/kit vs cupom). */
  function descontoTotalShopifyComparacao(cart) {
    return Math.max(0, descontoTotalShopify(cart) - valorDescontoPixNoCart(cart));
  }

  function percentualPixCheckoutCfg() {
    var p = cfgPromoDuo().percentualPixCheckout;
    return typeof p === 'number' && p > 0 && p < 1 ? p : 0;
  }

  function parcelasCartaoCfg() {
    var n = cfgPromoDuo().parcelasCartao;
    return typeof n === 'number' && n > 0 ? Math.floor(n) : 3;
  }

  /** Texto informativo (sem valores em R$ — frete e totais finais são no checkout). */
  function textoInfoPagamentoCarrinho() {
    var partes = [];
    var pct = percentualPixCheckoutCfg();
    if (pct) {
      partes.push(Math.round(pct * 100) + '% de desconto no PIX');
    }
    var parcelas = parcelasCartaoCfg();
    if (parcelas) {
      partes.push('até ' + parcelas + 'x sem juros no cartão');
    }
    if (!partes.length) return '';
    return 'Com ' + partes.join(' e ');
  }

  /** Total “pré-PIX” — PIX continua valendo no checkout, fora da disputa de cupons. */
  function totalShopifyParaComparacao(cart) {
    cart = cart || carrinho;
    return (Number(cart.total_price) || 0) + valorDescontoPixNoCart(cart);
  }

  function appDescontoEhNossoCupomPromo(app, cod) {
    if (!app || !cod || ehDescontoPix(app)) return false;
    var titulo = String(app.title || '').toUpperCase();
    var code = String(app.code || '').toUpperCase();
    if (titulo === cod || code === cod) return true;
    if ((app.type === 'discount_code' || app.type === 'code') && titulo.indexOf(cod) !== -1) return true;
    return false;
  }

  /** Cupom manual do cliente (não o código automático da promo par/kit). */
  function cupomExternoNoCart(cart) {
    cart = cart || carrinho;
    var codPromo = codigoPromoDuoCfg().toUpperCase();
    var codes = cart.discount_codes || [];
    for (var c = 0; c < codes.length; c++) {
      var entry = codes[c];
      if (entry.applicable === false) continue;
      var code = String(entry.code || '').toUpperCase();
      if (codPromo && code === codPromo) continue;
      if (code) return true;
    }
    var apps = cart.cart_level_discount_applications || [];
    for (var i = 0; i < apps.length; i++) {
      var app = apps[i];
      if (ehDescontoPix(app)) continue;
      if (app.type !== 'discount_code' && app.type !== 'code') continue;
      if (codPromo && appDescontoEhNossoCupomPromo(app, codPromo)) continue;
      return true;
    }
    return false;
  }

  function nossoCupomPromoAplicado(cart) {
    var cod = codigoPromoDuoCfg().toUpperCase();
    if (!cod) return false;
    cart = cart || carrinho;

    var codes = cart.discount_codes || [];
    for (var c = 0; c < codes.length; c++) {
      if (String(codes[c].code || '').toUpperCase() !== cod) continue;
      if (codes[c].applicable === false) return false;
      return true;
    }

    var apps = cart.cart_level_discount_applications || [];
    for (var i = 0; i < apps.length; i++) {
      if (appDescontoEhNossoCupomPromo(apps[i], cod)) return true;
    }

    var itens = cart.items || [];
    for (var j = 0; j < itens.length; j++) {
      var allocs = itens[j].line_level_discount_allocations || [];
      for (var k = 0; k < allocs.length; k++) {
        if (appDescontoEhNossoCupomPromo(allocs[k].discount_application, cod)) return true;
      }
    }
    return false;
  }

  /**
   * Exibe 10% par/kit calculado sempre que o carrinho qualifica.
   * Só desliga se outro cupom (não DUOPAR) já der desconto igual ou maior.
   */
  function usarPromoVitrine(cart) {
    cart = cart || carrinho;
    var promo = analisarPromoDuo(cart);
    if (!promo.elegivel || promo.descontoTotal <= 0) return false;
    if (!cupomExternoNoCart(cart)) return true;
    var descShopify = descontoTotalShopifyComparacao(cart);
    return descShopify + 10 < promo.descontoTotal;
  }

  function valorDescontoPromoExibido(cart) {
    var promo = analisarPromoDuo(cart);
    if (!promo.elegivel || promo.descontoTotal <= 0) return 0;
    if (!usarPromoVitrine(cart)) {
      return descontoTotalShopifyComparacao(cart);
    }
    /* Cupom DUOPAR na Shopify costuma ratear 10% no subtotal inteiro (ex.: 89,95),
       mas a vitrine cobra 10% só por par + kit (ex.: 71,96) — o total já bate com
       a vitrine; o resumo precisa mostrar o mesmo desconto, não o rateio bruto. */
    var sub = subtotalParaExibicao(cart);
    var totalVitrine = totalCalculadoPromoVitrine(cart);
    if (sub > 0 && totalVitrine != null) {
      var diff = sub - totalVitrine;
      if (diff > 0 && diff <= sub) return diff;
    }
    return promo.descontoTotal;
  }

  /** UI calculada: vitrine ganhou, cupom DUO ainda não refletiu no cart.js. */
  function uiPromoCalculada(cart) {
    return usarPromoVitrine(cart) && descontoTotalShopifyComparacao(cart) <= 0;
  }

  function rotuloCupomPromoDuo() {
    var cod = codigoPromoDuoCfg();
    return cod ? ('Cupom ' + cod) : 'Cupom promocional';
  }

  function linhasDescontoCupomPromoDuo(valorCent) {
    valorCent = Number(valorCent) || 0;
    if (valorCent <= 0) return [];
    return [{ rotulo: rotuloCupomPromoDuo(), valor: valorCent }];
  }

  function linhasDescontoShopifyReais(cart) {
    var linhas = [];
    var vistos = {};

    (cart.cart_level_discount_applications || []).forEach(function (app) {
      if (ehDescontoPix(app)) return;
      var valor = app.total_allocated_amount;
      if (valor == null) valor = app.amount;
      valor = Number(valor) || 0;
      if (valor <= 0) return;
      var rotulo = rotuloDesconto(app, app.title);
      var chave = rotulo + ':' + valor;
      if (vistos[chave]) return;
      vistos[chave] = true;
      linhas.push({ rotulo: rotulo, valor: valor });
    });

    (cart.items || []).forEach(function (item) {
      (item.line_level_discount_allocations || []).forEach(function (alloc) {
        var valor = Number(alloc.amount) || 0;
        if (valor <= 0) return;
        var app = alloc.discount_application || {};
        if (ehDescontoPix(app)) return;
        var rotulo = rotuloDesconto(app, app.title);
        var chave = rotulo + ':' + valor + ':line';
        if (vistos[chave]) return;
        vistos[chave] = true;
        linhas.push({ rotulo: rotulo, valor: valor });
      });
    });

    return linhas;
  }

  /**
   * Resumo do drawer: promo par/kit aparece como “Cupom DUOPAR10” (informativo).
   * O código só entra no carrinho se autoAplicarCodigoDuopar for true.
   */
  function linhasDesconto(cart) {
    var totalDescSemPix = descontoTotalShopifyComparacao(cart);
    var promo = analisarPromoDuo(cart);
    var linhasShopify = linhasDescontoShopifyReais(cart);

    if (cupomExternoNoCart(cart) && totalDescSemPix > 0) return linhasShopify;

    if (promo.elegivel && promo.descontoTotal > 0 && usarPromoVitrine(cart)) {
      var valorInfo = valorDescontoInformativoDuopar(cart);
      if (valorInfo > 0) return linhasDescontoCupomPromoDuo(valorInfo);
    }

    if (nossoCupomPromoAplicado(cart) && totalDescSemPix > 0) {
      return linhasDescontoCupomPromoDuo(totalDescSemPix);
    }

    return linhasShopify;
  }

  function totalCalculadoPromoVitrine(cart) {
    var promo = analisarPromoDuo(cart);
    if (!promo.elegivel || promo.descontoTotal <= 0) return null;
    return Math.max(0, subtotalParaExibicao(cart) - promo.descontoTotal);
  }

  function totalExibidoCarrinho(cart) {
    cart = cart || carrinho;
    var promo = analisarPromoDuo(cart);
    var totalSemPix = totalShopifyParaComparacao(cart);
    var totalVitrine = totalCalculadoPromoVitrine(cart);

    if (!promo.elegivel || promo.descontoTotal <= 0) {
      if (cupomExternoNoCart(cart)) return totalSemPix;
      return subtotalOriginal(cart);
    }

    if (!usarPromoVitrine(cart)) return totalSemPix;
    if (!autoAplicarCodigoDuoparCfg() && !nossoCupomPromoAplicado(cart)) {
      if (descontoTotalShopifyComparacao(cart) > 0) return totalSemPix;
    }
    if (nossoCupomPromoAplicado(cart)) {
      if (totalVitrine != null && Math.abs(totalSemPix - totalVitrine) > 10) return totalVitrine;
      return totalSemPix;
    }
    if (cupomExternoNoCart(cart) && descontoTotalShopifyComparacao(cart) > 0) return totalSemPix;

    return totalVitrine != null ? totalVitrine : totalSemPix;
  }

  function atualizarResumoPrecos(cart) {
    var resumoEl = qs('[data-ch-resumo-carrinho]');
    var subtotalEl = qs('[data-ch-subtotal-carrinho]');
    var descontosEl = qs('[data-ch-descontos-carrinho]');
    var totalEl = qs('[data-ch-total-carrinho]');
    if (!totalEl) return;

    var promo = analisarPromoDuo(cart);
    var vitrine = usarPromoVitrine(cart);
    var linhas = linhasDesconto(cart);
    var total = totalExibidoCarrinho(cart);
    var subtotal = linhas.length
      ? subtotalParaExibicao(cart)
      : subtotalOriginal(cart);
    var temDesconto = linhas.length > 0;

    if (resumoEl) resumoEl.hidden = !temDesconto;
    if (subtotalEl && temDesconto) subtotalEl.textContent = reais(subtotal);

    if (descontosEl) {
      if (!temDesconto || !linhas.length) {
        descontosEl.hidden = true;
        descontosEl.innerHTML = '';
      } else {
        descontosEl.hidden = false;
        descontosEl.innerHTML = linhas.map(function (l) {
          return '<div class="ch-carrinho__desconto">' +
            '<span class="ch-carrinho__desconto-rotulo">' + escHtml(l.rotulo) + '</span>' +
            '<span class="ch-carrinho__desconto-valor">&minus; ' + reais(l.valor) + '</span>' +
            '</div>';
        }).join('');
      }
    }

    var mostrarDe = temDesconto && subtotal > total;
    if (mostrarDe) {
      totalEl.innerHTML = htmlTotalComPromo(subtotal, total);
    } else {
      totalEl.textContent = reais(total);
    }
  }

  function imagemItem(item) {
    var info = infoVariante(item.variant_id);
    if (info && info.imagemFixa && info.imagem && urlImagemProdutoUtil(info.imagem)) {
      return info.imagem;
    }
    if (info && info.imagem && urlImagemProdutoUtil(info.imagem)) return info.imagem;
    if (info && info.imagemFixa) return info.imagem || '';
    if (item.image && urlImagemProdutoUtil(item.image)) return item.image;
    return '';
  }

  function desenharCarrinho() {
    var corpo = qs('[data-ch-corpo-carrinho]');
    var rodape = qs('[data-ch-rodape-carrinho]');
    if (!corpo || !rodape) { notificar(); return; }

    carrinho.items = carrinho.items || [];
    qsa('[data-contador-carrinho], [data-ch-contador-carrinho]').forEach(function (el) {
      el.textContent = carrinho.item_count;
    });

    if (!carrinho.items.length) {
      corpo.innerHTML = htmlCarrinhoVazio();
      rodape.hidden = true;
      notificar();
      atualizarUiBloqueioCart();
      return;
    }

    var qtdDescontoLinha = criarAlocadorDescontoCreatina(carrinho);
    var carregando = opsPendentes > 0;
    corpo.innerHTML = agruparItensPorVariante(carrinho.items).map(function (i) {
      var info = infoVariante(i.variant_id);
      var max = estoqueMaximo(info);
      var vid = escHtml(idVar(i.variant_id));
      var noLimite = info && info.inventory_management === 'shopify' && max > 0 && (i.quantity || 0) >= max;
      var qDesc = qtdDescontoLinha(i);
      var attrsMais = ' type="button" data-ch-mais="' + vid + '"';
      if (noLimite) attrsMais += ' data-ch-estoque-max="1"';
      return '<article class="ch-item">' +
        '<span class="ch-item__midia"><img src="' + imagemItem(i) + '" alt="" loading="lazy"></span>' +
        '<div>' +
          '<p class="ch-item__nome">' + escHtml(i.product_title || i.title || '') + '</p>' +
          '<p class="ch-item__variante">' + escHtml(i.variant_title || '') + '</p>' +
          '<div class="ch-item__linha">' +
            '<span class="ch-qtd">' +
              '<button type="button" data-ch-menos="' + vid + '"' +
                (carregando ? ' aria-disabled="true"' : '') + '>&minus;</button>' +
              '<span>' + i.quantity + '</span>' +
              '<button' + attrsMais + (noLimite ? ' disabled' : '') +
                (carregando ? ' aria-disabled="true"' : '') + '>+</button>' +
            '</span>' +
            htmlPrecoItem(i, carrinho, qDesc) +
          '</div>' +
          '<button class="ch-item__remover" type="button" data-ch-remover="' + vid + '">Remover</button>' +
        '</div></article>';
    }).join('') + htmlUpsellFecharPar(carrinho);

    rodape.hidden = false;
    var freteEl = qs('[data-ch-frete-carrinho]');
    var pagamentoEl = qs('[data-ch-pagamento-carrinho]');
    atualizarResumoPrecos(carrinho);
    if (pagamentoEl) {
      var txtPag = textoInfoPagamentoCarrinho();
      pagamentoEl.textContent = txtPag;
      pagamentoEl.hidden = !txtPag;
    }
    if (freteEl) freteEl.textContent = MSG_FRETE;
    notificar();
    atualizarUiBloqueioCart();
  }

  function recalcTotaisLocal() {
    carrinho.items = carrinho.items || [];
    carrinho.item_count = carrinho.items.reduce(function (t, i) { return t + (i.quantity || 0); }, 0);
    carrinho.total_price = carrinho.items.reduce(function (t, i) {
      return t + (i.final_line_price != null ? i.final_line_price : i.line_price || 0);
    }, 0);
  }

  /** Prévia na UI; a Shopify confirma depois. Falhou → desfazerPreview + GET cart.js */
  function previewAdd(variantId, qtd) {
    variantId = idVar(variantId);
    qtd = qtd || 1;
    if (linhasDaVariante(variantId).length) {
      previewQtdVariante(variantId, qtdNoCarrinho(variantId) + qtd);
      return;
    }
    var info = infoVariante(variantId);
    var preco = info ? info.preco : 0;
    var linha = preco * qtd;
    carrinho.items.push({
      variant_id: variantId,
      product_title: info ? info.produto : 'Produto',
      title: info ? info.produto : 'Produto',
      variant_title: info ? info.variante : '',
      quantity: qtd,
      price: preco,
      line_price: linha,
      final_line_price: linha,
      original_line_price: linha,
      __preview: true
    });
    recalcTotaisLocal();
    desenharCarrinho();
  }

  function previewQtdVariante(variantId, novaQtd) {
    variantId = idVar(variantId);
    if (novaQtd <= 0) {
      previewRemoveVariante(variantId);
      return;
    }
    var info = infoVariante(variantId);
    var primeira = null;
    carrinho.items = carrinho.items.filter(function (i) {
      if (!mesmosIds(i.variant_id, variantId)) return true;
      if (!primeira) {
        primeira = i;
        return true;
      }
      return false;
    });
    if (!primeira) {
      previewAdd(variantId, novaQtd);
      return;
    }
    primeira.quantity = novaQtd;
    primeira.__preview = true;
    var unit = primeira.price || (info ? info.preco : 0);
    if (unit) {
      primeira.line_price = unit * novaQtd;
      primeira.final_line_price = primeira.line_price;
      primeira.original_line_price = primeira.line_price;
    }
    recalcTotaisLocal();
    desenharCarrinho();
  }

  function previewRemoveVariante(variantId) {
    variantId = idVar(variantId);
    carrinho.items = carrinho.items.filter(function (i) { return !mesmosIds(i.variant_id, variantId); });
    recalcTotaisLocal();
    desenharCarrinho();
  }

  function desfazerPreviewVariante(variantId) {
    variantId = idVar(variantId);
    carrinho.items = (carrinho.items || []).filter(function (i) {
      return !(i.__preview && mesmosIds(i.variant_id, variantId));
    });
    recalcTotaisLocal();
    desenharCarrinho();
  }

  function limparTimerAvisoSucesso() {
    if (timerAvisoSucesso) {
      clearTimeout(timerAvisoSucesso);
      timerAvisoSucesso = null;
    }
  }

  function ehAvisoAddSucesso(msg) {
    return typeof msg === 'string' && /adicionado ao carrinho/i.test(msg);
  }

  function definirAvisoCarrinho(msg) {
    var aviso = qs('[data-ch-aviso-carrinho]');
    if (!aviso) return;
    limparTimerAvisoSucesso();
    aviso.classList.remove('ch-saindo');
    if (msg) {
      aviso.textContent = msg;
      aviso.classList.add('ch-visivel');
      if (ehAvisoAddSucesso(msg)) {
        timerAvisoSucesso = setTimeout(function () {
          aviso.classList.add('ch-saindo');
          timerAvisoSucesso = setTimeout(function () {
            definirAvisoCarrinho('');
          }, MS_AVISO_FADE);
        }, MS_AVISO_SUCESSO);
      }
    } else {
      aviso.textContent = '';
      aviso.classList.remove('ch-visivel', 'ch-saindo');
    }
  }

  function abrirCarrinho(msg) {
    qsa('[data-ch-checkout]').forEach(function (btn) {
      if (btn.getAttribute('aria-busy') === 'true') setCheckoutLoading(btn, false);
    });
    var gaveta = qs('#ch-carrinho');
    var fundo = qs('[data-ch-fundo-carrinho]');
    if (!gaveta || !fundo) return;
    fundo.hidden = false;
    fundo.classList.add('ch-aberto');
    gaveta.classList.add('ch-aberto');
    gaveta.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    definirAvisoCarrinho(msg);
  }

  function irParaAreaProdutos() {
    fecharCarrinho();
    var sec = document.getElementById('kits');
    if (sec) {
      sec.scrollIntoView({ behavior: 'smooth', block: 'start' });
      try {
        if (window.history && window.history.replaceState) {
          window.history.replaceState(null, '', window.location.pathname + '#kits');
        }
      } catch (e) { /* ignore */ }
      return;
    }
    var url = CFG.lojaProdutos;
    if (!url) {
      var root = (CFG.root || '/');
      root = String(root);
      if (root.slice(-1) !== '/') root += '/';
      url = root + '?produtos=1';
    }
    window.location.assign(url);
  }

  function htmlCarrinhoVazio() {
    return '<div class="ch-carrinho__vazio">' +
      '<p>Seu carrinho ainda está vazio. Bora escolher um sabor?</p>' +
      '<button type="button" class="ch-botao ch-botao--largo" data-ch-ir-produtos>Adicionar produtos</button>' +
      '</div>';
  }

  function fecharCarrinho() {
    var gaveta = qs('#ch-carrinho');
    var fundo = qs('[data-ch-fundo-carrinho]');
    if (!gaveta || !fundo) return;
    definirAvisoCarrinho('');
    gaveta.classList.remove('ch-aberto');
    gaveta.setAttribute('aria-hidden', 'true');
    fundo.classList.remove('ch-aberto');
    document.body.style.overflow = '';
    window.setTimeout(function () {
      if (!gaveta.classList.contains('ch-aberto')) fundo.hidden = true;
    }, 450);
  }

  function tratarErroCart(err, variantId) {
    if (tratarRateLimit(err)) {
      abrirCarrinho(msgRateLimit());
      return;
    }
    if (err && err.status === 422) {
      abrirCarrinho(mensagemIndisponivel(infoVariante(variantId)));
      return;
    }
    abrirCarrinho((err && err.description) || (err && err.message) || 'Não foi possível atualizar o carrinho.');
  }

  /** cart/add.js → GET cart.js (ordem e linhas = Shopify). */
  function adicionar(variantId, qtd, nomeSucesso) {
    variantId = idVar(variantId);
    qtd = Math.max(1, qtd || 1);
    if (addPorVariantEmVoo[variantId]) return addPorVariantEmVoo[variantId];
    if (apiBloqueada()) {
      abrirCarrinho(msgRateLimit());
      return Promise.reject({ status: 'too_many_requests' });
    }

    var check = validarEstoque(variantId, qtd);
    if (!check.ok) {
      abrirCarrinho(check.msg);
      return Promise.resolve();
    }

    var info = infoVariante(variantId);
    var msgOk = (nomeSucesso || (info && info.produto) || 'Produto') + ' adicionado ao carrinho.';

    abrirCarrinho(msgOk);
    previewAdd(variantId, qtd);

    var promessa = comFila(function () {
      return postIncrementarVariante(variantId, qtd);
    }).catch(function (err) {
      console.error('[IMGCart]', err);
      desfazerPreviewVariante(variantId);
      return buscarCarrinhoDireto().then(function () {
        tratarErroCart(err, variantId);
        throw err;
      });
    }).finally(function () {
      delete addPorVariantEmVoo[variantId];
    });
    addPorVariantEmVoo[variantId] = promessa;
    return promessa;
  }

  function alterarLinha(variantId, delta) {
    variantId = idVar(variantId);
    if (!linhasDaVariante(variantId).length && delta < 0) return Promise.resolve();
    if (qtyPorVariantEmVoo[variantId]) return qtyPorVariantEmVoo[variantId];

    if (delta > 0) {
      var check = validarEstoque(variantId, delta);
      if (!check.ok) {
        abrirCarrinho(check.msg);
        return Promise.resolve();
      }
    }

    var promessa = comFila(function () {
      return fetch(urlCart('get'), { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(parseRespostaCart)
        .then(function (cart) {
          var alvo = qtdVarianteNoCartServidor(cart, variantId) + delta;
          if (alvo < 0) alvo = 0;
          return postDefinirQtyVarianteFromCart(cart, variantId, alvo);
        })
        .then(finalizarMudancaCart);
    }).catch(function (err) {
      console.error('[IMGCart]', err);
      return buscarCarrinhoDireto().then(function () {
        tratarErroCart(err, variantId);
        throw err;
      });
    }).finally(function () {
      delete qtyPorVariantEmVoo[variantId];
    });
    qtyPorVariantEmVoo[variantId] = promessa;
    return promessa;
  }

  function removerLinha(variantId) {
    variantId = idVar(variantId);
    if (!linhasDaVariante(variantId).length) return Promise.resolve();

    return comFila(function () {
      return postDefinirQtyVariante(variantId, 0);
    }).catch(function (err) {
      console.error('[IMGCart]', err);
      return buscarCarrinhoDireto().then(function () {
        tratarErroCart(err, variantId);
        throw err;
      });
    });
  }

  function irParaCheckoutForm() {
    var root = String(CFG.root || '/');
    if (root.indexOf('http') !== 0 && root.slice(-1) !== '/') root += '/';
    var action = root.indexOf('http') === 0 ? root + 'cart' : '/cart';
    var form = document.createElement('form');
    form.method = 'POST';
    form.action = action;
    form.style.display = 'none';
    var checkout = document.createElement('input');
    checkout.type = 'hidden';
    checkout.name = 'checkout';
    checkout.value = '';
    form.appendChild(checkout);
    document.body.appendChild(form);
    form.submit();
  }

  function irParaCheckoutShopify() {
    return filaCart
      .then(function () { return buscarCarrinhoDireto(); })
      .then(function (cart) { return sincronizarCodigoPromoDuo(cart || carrinho, { forcar: true }); })
      .then(function () {
        if (!carrinho.item_count) throw new Error('empty');
        window.location.assign(urlCheckout());
      });
  }

  function setCheckoutLoading(btn, ativo) {
    if (!btn) return;
    if (ativo) {
      if (!btn.dataset.chCheckoutLabel) {
        btn.dataset.chCheckoutLabel = (btn.textContent || '').trim() || 'Comprar agora';
      }
      btn.setAttribute('aria-busy', 'true');
      btn.setAttribute('aria-disabled', 'true');
      btn.classList.add('ch-botao--carregando');
      btn.textContent = 'Redirecionando…';
      return;
    }
    btn.removeAttribute('aria-busy');
    btn.removeAttribute('aria-disabled');
    btn.classList.remove('ch-botao--carregando');
    btn.textContent = btn.dataset.chCheckoutLabel || 'Comprar agora';
    atualizarBotaoCheckout();
  }

  /** Volta do checkout (bfcache) deixa “Redirecionando…” preso — limpa fila/UI. */
  function resetEstadoPosNavegacao() {
    opsPendentes = 0;
    qsa('[data-ch-checkout]').forEach(function (btn) {
      setCheckoutLoading(btn, false);
    });
    atualizarUiBloqueioCart();
  }

  function atualizarVarianteRemota(variantId, forcar) {
    variantId = idVar(variantId);
    if (!variantId || apiBloqueada()) return Promise.resolve();
    var agora = Date.now();
    if (!forcar && variantRefreshEm[variantId] && agora - variantRefreshEm[variantId] < 60000) {
      return Promise.resolve();
    }
    var root = (CFG.root || '/');
    if (root.slice(-1) !== '/') root += '/';
    return fetch(root + 'variants/' + variantId + '.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (v) {
        variantRefreshEm[variantId] = Date.now();
        if (v) aplicarDadosVariante(v);
        notificar();
      })
      .catch(function () {});
  }

  function atualizarEstoqueRemoto() {
    var ids = Object.keys(VARIANTES()).filter(function (k) { return idVar(k) !== ''; });
    if (!ids.length) return Promise.resolve();
    var chain = Promise.resolve();
    ids.forEach(function (id) {
      chain = chain.then(function () { return atualizarVarianteRemota(id, false); });
    });
    return chain;
  }

  document.addEventListener('click', function (e) {
    var alvo;

    alvo = e.target.closest('[data-kit-adicionar]');
    if (alvo) {
      e.preventDefault();
      e.stopImmediatePropagation();
      if (alvo.getAttribute('aria-busy') === 'true' || alvo.disabled) return;
      var produtosIndex = window.IMG_PRODUCTS || {};
      var skuKit = alvo.getAttribute('data-kit-adicionar');
      var kitEl = alvo.closest('.kit');
      var variantIdKit = alvo.getAttribute('data-variant-id') || (kitEl ? kitEl.getAttribute('data-variant-id') : null);
      if (!variantIdKit && produtosIndex[skuKit]) variantIdKit = produtosIndex[skuKit].variant_id;
      var qtdElKit = kitEl ? kitEl.querySelector('[data-qtd-valor]') : null;
      var qtdKit = qtdElKit ? Math.max(1, Number(qtdElKit.textContent) || 1) : 1;
      if (!variantIdKit) {
        abrirCarrinho('Produto não encontrado. Confira se Creatina I\'M Goodies e o Kit estão publicados na loja.');
        return;
      }
      alvo.setAttribute('aria-busy', 'true');
      adicionar(variantIdKit, qtdKit, produtosIndex[skuKit] && produtosIndex[skuKit].produto)
        .then(function () {
          if (qtdElKit) qtdElKit.textContent = '1';
        })
        .catch(function () {})
        .finally(function () {
          alvo.removeAttribute('aria-busy');
          if (typeof window.IMG_aplicarEstadoKits === 'function') window.IMG_aplicarEstadoKits();
        });
      return;
    }

    alvo = e.target.closest('[data-abrir-carrinho], [data-ch-abrir-carrinho]');
    if (alvo) { e.preventDefault(); abrirCarrinho(); return; }

    alvo = e.target.closest('[data-ch-fechar-carrinho], [data-ch-fundo-carrinho]');
    if (alvo) { e.preventDefault(); fecharCarrinho(); return; }

    alvo = e.target.closest('[data-ch-ir-produtos]');
    if (alvo) {
      e.preventDefault();
      irParaAreaProdutos();
      return;
    }

    alvo = e.target.closest('[data-ch-checkout]');
    if (alvo) {
      e.preventDefault();
      if (alvo.getAttribute('aria-busy') === 'true') return;
      if (alvo.getAttribute('aria-disabled') === 'true' || opsPendentes > 0) return;
      setCheckoutLoading(alvo, true);
      var checkoutHref = alvo.href || urlCheckout();
      irParaCheckoutShopify().catch(function (err) {
        if (carrinho.item_count > 0) {
          window.location.assign(checkoutHref);
          return;
        }
        setCheckoutLoading(alvo, false);
        if ((err && err.message === 'empty') || !carrinho.item_count) {
          abrirCarrinho('Seu carrinho está vazio. Escolha um produto primeiro.');
          return;
        }
        console.error('[IMGCart] checkout', err);
        abrirCarrinho('Não foi possível ir ao checkout agora. Tente de novo em instantes.');
      });
      return;
    }

    alvo = e.target.closest('[data-ch-mais]');
    if (alvo) {
      e.preventDefault();
      e.stopImmediatePropagation();
      if (alvo.disabled) return;
      alterarLinha(alvo.getAttribute('data-ch-mais'), 1);
      return;
    }

    alvo = e.target.closest('[data-ch-menos]');
    if (alvo) {
      e.preventDefault();
      e.stopImmediatePropagation();
      if (alvo.disabled) return;
      alterarLinha(alvo.getAttribute('data-ch-menos'), -1);
      return;
    }

    alvo = e.target.closest('[data-ch-upsell-add]');
    if (alvo) {
      e.preventDefault();
      var vidUpsell = alvo.getAttribute('data-ch-upsell-add');
      var infoUps = infoVariante(vidUpsell);
      adicionar(vidUpsell, 1, infoUps && infoUps.produto);
      return;
    }

    alvo = e.target.closest('[data-ch-remover]');
    if (alvo) {
      e.preventDefault();
      removerLinha(alvo.getAttribute('data-ch-remover'));
      return;
    }
  }, true);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && qs('#ch-carrinho.ch-aberto')) fecharCarrinho();
  });

  window.IMGCart = {
    add: adicionar,
    change: alterarLinha,
    remove: removerLinha,
    open: abrirCarrinho,
    close: fecharCarrinho,
    qtyInCart: qtdNoCarrinho,
    maxStock: function (variantId) { return estoqueMaximo(infoVariante(variantId)); },
    podeComprar: function (variantId) { return estoqueMaximo(infoVariante(variantId)) > 0; },
    vendeSemEstoque: function (variantId) { return vendeSemEstoque(infoVariante(variantId)); },
    checkStock: validarEstoque,
    subscribe: function (fn) { assinantes.push(fn); },
    refreshStock: atualizarEstoqueRemoto,
    refreshVariant: atualizarVarianteRemota,
    reload: buscarCarrinho,
    /** Re-render só a UI (ex.: após IMG_VARIANTS no fim da página). */
    redraw: function () {
      if ((carrinho.items || []).length) desenharCarrinho();
    },
    state: function () { return carrinho; }
  };

  window.addEventListener('pageshow', function (ev) {
    if (!ev.persisted) return;
    resetEstadoPosNavegacao();
    buscarCarrinho();
  });

  function limparQueryAbrirCarrinho() {
    if (!window.history || !window.history.replaceState) return;
    var params = new URLSearchParams(window.location.search);
    params.delete('open_cart');
    params.delete('carrinho');
    var q = params.toString();
    var url = window.location.pathname + (q ? '?' + q : '') + window.location.hash;
    window.history.replaceState(null, '', url);
  }

  function deveAbrirCarrinhoPorUrl() {
    var params = new URLSearchParams(window.location.search);
    var v = params.get('open_cart');
    if (v === '1' || v === 'true') return true;
    v = params.get('carrinho');
    return v === '1' || v === 'abrir' || v === 'open';
  }

  function tratarDeepLinkAbrirCarrinho() {
    if (!deveAbrirCarrinhoPorUrl()) return;
    requestAnimationFrame(function () {
      abrirCarrinho();
      limparQueryAbrirCarrinho();
    });
  }

  buscarCarrinho();
  tratarDeepLinkAbrirCarrinho();
})();
